// Segmented choice = Aurora <Tabs> (default variant); panels are empty.
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@aurora-reactkit/components/tabs';
import type { ReactNode } from 'react';

interface Option<T extends string> { value: T; label: ReactNode; testId?: string }
interface Props<T extends string> { label: string; value: T; options: Option<T>[]; onChange: (v: T) => void }

export function Segmented<T extends string>({ label, value, options, onChange }: Props<T>) {
  return (
    <Tabs<T> value={value} onChange={onChange}>
      <TabsList aria-label={label}>
        {options.map((o) => (
          <TabsTrigger key={o.value} value={o.value} data-testid={o.testId}>{o.label}</TabsTrigger>
        ))}
      </TabsList>
      {/* Empty panels keep aria-controls valid; the choice itself is the content. */}
      {options.map((o) => <TabsContent key={o.value} value={o.value} />)}
    </Tabs>
  );
}
